import { RegionCard } from './components/RegionCard';

export function RegionList({ regions }: Readonly<{ regions: any[] }>) {
  return (
    <div className='grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3'>
      {regions.map((region) => (
        <RegionCard key={region.id} region={region} />
      ))}
    </div>
  );
}
